// extracted by mini-css-extract-plugin
module.exports = {"message":"_1300f35","icon":"_e2a0df3"};